// Import global styles
import "@fontsource-variable/geist";
import "@fontsource-variable/inter";
import "@fontsource-variable/geist-mono";
import './src/styles/global.scss';

// Import analytics
import { analytics } from './src/utils/analytics';

// Track if this is the first page load
let isFirstLoad = true;

/**
 * Initialize analytics when the browser starts
 */
export const onClientEntry = () => {
  if (typeof window === 'undefined') {
    return;
  }

  // Initialize analytics immediately (no delay)
  analytics.init(false);
  
  // Expose analytics to window for testing (only in development)
  if (process.env.NODE_ENV === 'development') {
    window.analytics = analytics;
  }
};

/**
 * Track page loads on initial load and route changes
 */
export const onRouteUpdate = ({ location }) => {
  if (typeof window === 'undefined') {
    return;
  }

  // For the first page load, wait a bit longer to ensure analytics is ready
  const delay = isFirstLoad ? 300 : 100;
  
  setTimeout(() => {
    const maxRetries = 5;
    let retryCount = 0;

    const tryTrackPageLoad = () => {
      if (analytics.isInitialized()) {
        analytics.trackPageLoad(location.pathname);
        isFirstLoad = false;
      } else if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(tryTrackPageLoad, 200);
      }
    };

    tryTrackPageLoad();
  }, delay);
};
